<div class="flex flex-col h-[76vh]">
  <section class="h-[90%] pr-6 overflow-auto">
    <file-list-upload-v2-mobile [data]="data" [origin]="'mobile'"></file-list-upload-v2-mobile>
  </section>
  <section class="h-[10%] pr-6">
    <mat-divider class="mat-divider m-0 sm:mb-6 sm:mt-[42px]" aria-orientation="horizontal"></mat-divider>
    <div class="flex items-start justify-between w-full h-[65px] pl-0 pr-0 max-[480px]:pt-4">
      <button class="app__centered-item bg-transparent font-bold text-xs gap-2 cursor-pointer" (click)="handleSteps('backward')">
        <span class="app__centered-item gap-2 text-[#18191C]"
          ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
        >
      </button>
      <div class="w-[158px]">
        <button
          class="app__btn--primary mt-0 max-[480px]:items-center max-[480px]:h-[38px] max-[480px]:m-0"
          type="submit"
          (click)="handleSteps('forward')"
        >
          Continue
        </button>
      </div>
    </div>
  </section>
</div>
